import type { DashboardBriefingRequest, DashboardBriefingResponse } from '@testflow/shared';
import { request } from './api.js';

const base = (p: string) => `/v1/projects/${p}`;

export const dashboardApi = {
  // #62: schickt die schon berechneten Dashboard-Aggregate der aktuellen Rolle an das opt-in
  // KI-Briefing. Die ROLLE wird NICHT mitgeschickt — der Server leitet sie aus dem Login ab.
  briefing(projectId: string, input: DashboardBriefingRequest): Promise<DashboardBriefingResponse> {
    return request<DashboardBriefingResponse>(`${base(projectId)}/dashboard/briefing`, {
      method: 'POST',
      body: JSON.stringify(input),
    });
  },
};
